import logo from "./../images/logo.png"
import center_img from "./../images/center_image.svg"
import person from "./../images/person.png"
import admin from "./../images/admin.svg"


export const sessionOne = {
  dateAndTime: "Sept 8th, 2pm EDT",
  calendarLink: "https://docs.google.com/forms/u/0/",
};

export const sessionTwo = {
  dateAndTime: "Sept 13th, 9am EDT",
  calendarLink: "https://docs.google.com/forms/u/0/",
};

export const logoImage =
  logo;

export const centerImage = 
  center_img;

export const personImage =
  person;

export const adminImage = 
 admin;